export class LivestreamWizardSectionComponent {
    open = false;
}

angular.module('tradersyard').component('tyLivestreamWizardSection', {
    // language=HTML
    template: `
        <div class="livestream_wizard_section" ng-class="{'is-open': $ctrl.open, 'is-closed': !$ctrl.open}">
            <div class="livestream_wizard_section__header" ng-click="$ctrl.onOpenChanged({open: !$ctrl.open})">
                <div class="livestream_wizard_section__main">
                    <div class="livestream_wizard_section__name" ng-transclude="name"></div>
                    <div class="livestream_wizard_section__heading hide-when-open" ng-hide="$ctrl.open" ng-transclude="heading"></div>
                    <div class="livestream_wizard_section__description hide-when-open" ng-hide="$ctrl.open" ng-transclude="description"></div>
                </div>
                <div class="livestream_wizard_section__side hide-when-open" ng-hide="$ctrl.open">
                    <button class="btn btn-link" ng-transclude="buttonText">setup</button>
                </div>
            </div>
            <div class="livestream_wizard_section__content" ng-transclude="content" uib-collapse="!$ctrl.open"></div>
        </div>
    `,
    controller: LivestreamWizardSectionComponent,
    transclude: {
        heading: 'heading',
        name: 'name',
        description: '?description',
        buttonText: 'buttonText',
        content: 'wizardBody',
    },
    bindings: {
        open: '<',
        onOpenChanged: '&',
    },
});
